//Do not assume team two is enemy, because that team also uses this function (EX: Bug) so team "one" is the enemy for them.
export function getLeadEnemy(enemyTeam) {
  return enemyTeam.find(c => c.isLeadEnemy) || enemyTeam[0]; //default to first enemy
}